import script from "./HeroVisual.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroVisual.vue?vue&type=script&setup=true&lang=ts"

import "./HeroVisual.vue?vue&type=style&index=0&id=1bea3e08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bea3e08"]])

export default __exports__